export default "invalid-workshop-link = 不正确的Steam创意工坊链接\ninvalid-youtube-link = 不正确的Youtube链接\nrequired = 这是一个必填项\n"